import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

import theme from '@themes/default';

import { AlignType } from './index';

export const VoucherDiscountInfoWrapper = styled.div`
  margin: -0.3rem 0 0.75rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const DiscountInfoDescription = styled.div<{
  align: AlignType;
}>`
  text-align: ${({ align }) => align};
`;

export const DiscountAmmountWrapper = styled.span`
  color: ${theme.palette.primary};
  font-weight: bold;
`;

export const CodeWrapper = styled.span`
  font-weight: bold;
  text-transfrom: uppercase;
  color: ${theme.palette.basic};
`;

export const TermsWrapper = styled.div<{ align: AlignType }>`
  font-size: 0.75rem;
  color: ${theme.palette.neutralDark};
  font-weight: normal;
  display: flex;
  justify-content: ${({ align }) =>
    align === 'right' ? 'flex-end' : 'flex-start'};
  align-items: flex-start;

  @media (min-width: ${breakpoints.sm}) {
    align-items: center;
  }

  @media (min-width: ${breakpoints.lg}) {
    margin-top: 0.2rem;
  }
`;

export const TextWrapper = styled.div`
  color: ${theme.palette.basic};
  font-weight: 300;
`;

export const VoucherDiscountIconWrapper = styled.div<{
  hideDesktop: boolean;
  align: AlignType;
}>`
  margin: ${({ align }) => (align === 'right' ? '0 0 0 1rem' : '0 1rem 0 0')};
  height: 2.25rem;
  display: block;
  @media (min-width: ${breakpoints.sm}) {
    display: ${({ hideDesktop }) => (hideDesktop ? 'none' : 'block')};
    margin: 0 0 0 1rem;
  }
`;

export const InfoIconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-top: 0.1rem;

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const TooltipContent = styled.div`
  min-width: 8rem;
  text-align: center;
  @media (min-width: ${breakpoints.sm}) {
    min-width: 15rem;
  }
`;

export const InstructionTextWrapper = styled.span`
  padding-right: 0.3rem;
`;
